<div class="cf">
  <div class="margin-bottom-20">
    <div class="bluebg-blocks be-data-box">
      <ul>
        <li>
          <div class="whiteblock">
            <label class="be-label margin-bottom-10">
              Asking Price
              <span style="background-color: rgb(236, 85, 85);"></span>
            </label>
            <h3 *ngIf="UnPriced">Unpriced</h3>
            <h3 *ngIf="!UnPriced">{{(askingPrice)?  "$ " + (askingPrice| number:0) : "-"}}</h3>
          </div>
        </li>
        <li>
          <div class="whiteblock">
            <label class="be-label">
              Rent / NOI
              <span style="background-color: rgb(242, 189, 102);"></span>
            </label>
            <h3>{{(noi) ? "$ "+( noi| number:0) : "-"}}</h3>
          </div>
        </li>
        <li>
          <div class="whiteblock">
            <label class="be-label margin-bottom-10">
              Cap Rate
              <span style="background-color: rgb(91, 200, 175);"></span>
            </label>
            <h3>
              <p *ngIf="!zcf">{{(capRate) ? (capRate | number:0) + "%" : "-" }}</p>
              <p *ngIf="zcf">ZCF</p>
            </h3>
          </div>
        </li>
        <li>
          <div class="whiteblock">
            <label class="be-label margin-bottom-10">
              Avg. Remaining Term
              <span style="background-color: rgb(25, 143, 222);"></span>
            </label>
            <!--<h3>{{avgRemainingTerm ? (this.property.PortfolioRemainingLeaseTerm ? avgRemainingTerm : (avgRemainingTerm | yearsMonthConverter:true)) : "-" }}</h3>-->

            <h3>{{avgRemainingTerm}}</h3>
          </div>
        </li>
        <li>
          <div class="whiteblock">
            <label class="be-label margin-bottom-10">
              Total Building SF
              <span style="background-color: rgb(134, 71, 179);"></span>
            </label>
            <h3>
              {{
avgArea ? (avgArea| number) + " SF" : "-"
              }}
            </h3>
          </div>
        </li>
      </ul>


    </div>
  </div>
  <div class="cf">
    <div>
      <div class="table-responsive margin-bottom-10">
        <table class="table basictable row-border hover">
          <thead>
            <tr>
              <th [hidden]="leadDetailsGuid != null"></th>
              <th>Tenant/Portfolio</th>
              <th>State</th>
              <th>City</th>
              <th>Property Type</th>
              <th>Asking Price</th>
              <th>Rent / NOI</th>
              <th>Cap Rate</th>
              <th>Remaining Term</th>
              <th>Lease Structure</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="property != null && leadDetailsGuid == null" class="all_td_bold">
              <td>
                <label class="custom-checkbox withoutlabel">
                  <input [attr.disabled]="property.IsOfferOnAllProperties != null && property.IsOfferOnAllProperties == true ? '':null" type="checkbox" #InputCheckAll [(ngModel)]="selectAll" (change)="onSelectAll(InputCheckAll.checked);" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>
              <td>{{property.Tenant}}</td>
              <td *ngIf="!haveaccesstoviewlocation1">Confidential</td>
              <td *ngIf="haveaccesstoviewlocation1">{{property.State ? property.State : '-'}}</td>
              <td>{{property.City ? property.City : '-'}}</td>
              <td>{{property.AssetType ? property.AssetType : '-'}}</td>
              <td>
                <p class="whitespacenowrap" *ngIf="!property.Unpriced">{{(property.Price) ? '$ '+ (property.Price | number:0) : '-'}}</p>
                <p class="whitespacenowrap" *ngIf="property.Unpriced">Unpriced</p>
              </td>
              <td><p class="whitespacenowrap">{{(property.NetOperatingIncome) ? '$ '+ (property.NetOperatingIncome | number:0) : '-'}}</p></td>
              <td>
                <p *ngIf="!property.OnlyZCF">{{(property.CapRate) ?  (property.CapRate | number:0) + '%': '-'}}</p>
                <p *ngIf="property.OnlyZCF">ZCF</p>
              </td>
              <td>{{property.PortfolioRemainingLeaseTerm ? property.PortfolioRemainingLeaseTerm : '-'}}</td>
              <td>{{property.LeaseStructure ? property.LeaseStructure : '-'}}</td>
              <!--<td>{{property.BuildingSize ? property.BuildingSize : '-'}}</td>-->
              <td><p [ngClass]="{'redtextlabel':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),'greentextlabel':property.PropertyStatus === 'Available','orangetextlabel':property.PropertyStatus === 'Under Contract','not-available':property.PropertyStatus === 'Not Available','Off-Market':property.PropertyStatus === 'Off-Market'}">{{ property.PropertyStatus }}</p></td>
            </tr>
            <tr *ngFor="let propertyItem of propertylist; let i = index;">
              <td [hidden]="leadDetailsGuid != null">
                <label class="custom-checkbox withoutlabel">
                  <input [attr.disabled]="property.IsOfferOnAllProperties != null && property.IsOfferOnAllProperties == true ? '':null" #InputPropertyChack type="checkbox" [(ngModel)]="propertyItem.IsChecked" (change)="onSelect(InputPropertyChack.checked, propertyItem);" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>
              <td>{{propertyItem.PropertyName }}</td>
              <td *ngIf="!haveaccesstoviewlocation">{{propertyItem.ConfidentialLocation?'Confidential':propertyItem.State ? propertyItem.State : '-'}}</td>
              <td *ngIf="haveaccesstoviewlocation">{{propertyItem.State ? propertyItem.State : '-'}}</td>
              <td *ngIf="!haveaccesstoviewlocation">{{propertyItem.ConfidentialLocation?'Confidential':propertyItem.City ? propertyItem.City : '-'}}</td>
              <td *ngIf="haveaccesstoviewlocation">{{propertyItem.City ? propertyItem.City : '-'}}</td>
              <td>{{propertyItem.AssetType ? propertyItem.AssetType : '-'}}</td>
              <td>
                <p class="whitespacenowrap" *ngIf="!propertyItem.Unpriced">{{(propertyItem.Price) ? '$ '+ (propertyItem.Price | number:0) : '-'}}</p>
                <p class="whitespacenowrap" *ngIf="propertyItem.Unpriced">Unpriced</p>
              </td>
              <td><p class="whitespacenowrap">{{(propertyItem.RentNOI) ? '$ '+ (propertyItem.RentNOI | number:0) : '-'}}</p></td>
              <td>
                <p *ngIf="propertyItem.CharacteristicsId == 0">{{(propertyItem.CapRate) ?  (propertyItem.CapRate | number:0) + '%': '-'}}</p>
                <p *ngIf="propertyItem.CharacteristicsId == 1">ZCF</p>
              </td>
              <td>{{propertyItem.RemainingTerm ? (propertyItem.RemainingTerm | yearsMonthConverter:true) : '-'}}</td>
              <td>{{propertyItem.LeaseStructure ? propertyItem.LeaseStructure : '-'}}</td>
              <!--<td>{{propertyItem.BuildingSize ? propertyItem.BuildingSize : '-'}}</td>-->
              <td><p [ngClass]="{'redtextlabel':(propertyItem.PropertyStatus === 'Closed' || propertyItem.PropertyStatus === 'Sold'),'greentextlabel':propertyItem.PropertyStatus === 'Available','orangetextlabel':propertyItem.PropertyStatus === 'Under Contract','not-available':propertyItem.PropertyStatus === 'Not Available','Off-Market':propertyItem.PropertyStatus === 'Off-Market'}">{{ propertyItem.PropertyStatus }}</p></td>
            </tr>
          </tbody>
          <tfoot>
            <tr *ngIf="propertylist?.length == 0 ">
              <td colspan="11" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>

</div>
